import React from 'react'
import type { FC } from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles'

import { WindowTitle } from '@homeviews/shared-ui'
import { Typography } from '@homeviews/outreach'

const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      padding: '24px 16px',
    },
    topHeaderWrapper: {
      display: 'flex',
      marginBottom: '18px',
    },
    customH1: {
      '.MuiTypography-h1&': {
        whiteSpace: 'nowrap',
        marginBottom: 0,
      },
    },
  }),
)

export const PageLayout: FC = ({ children }) => {
  const classes = useStyles()

  return (
    <div className={classes.wrapper}>
      <WindowTitle title="Resident Email Tool" />
      <div className={classes.topHeaderWrapper}>
        <Typography variant="h1" className={classes.customH1}>
          Resident Email Tool
        </Typography>
        <Typography variant="subtitle1">
          Collect resident reviews at key moments in their journey, with the
          HomeViews email outreach tool.
        </Typography>
      </div>
      {children}
    </div>
  )
}
